import secureAxios from '../secure_axios';

const baseUrl = 'indicador'

async function servPostIndicadorLote(formData) {
    const { data } = await secureAxios.post(
        `${baseUrl}/lote`,
        formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );
    return data
}

async function servGetIndicadorComHistorico(query) {
    const { data } = await secureAxios.get(
        `${baseUrl}/historico`,
        { params: query }
    )
    return data
}

async function servPatchIndicador(query) {
    const { data } = await secureAxios.patch(
        baseUrl,
        query
    )
    return data
}

export {
    servPostIndicadorLote,
    servGetIndicadorComHistorico,
    servPatchIndicador
}
